import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import './CookiePopup.css'
import { Link } from "react-router-dom";

const CookiePopup = () => {
  const [isVisible, setIsVisible] = useState(!Cookies.get("cookieConsent"));

  useEffect(() => {
    const cookieConsent = Cookies.get("cookieConsent");

    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
      Cookies.set("cookieConsent", "true", { expires: 7, path: "/" });
      setIsVisible(false);
  };

  const handleDecline = () => {
    setIsVisible(false); 
  };

  return (
    <>
      {isVisible && (
        <div className="cookie-popup">
          <div className="cookie-content">
            <p>
              We use cookies to ensure you get the best experience on our website. By accepting, you agree to our use of 
              <Link to="/cookies-policy">cookies.</Link>
            </p>
            <div className="cookie-actions">
              <button onClick={handleDecline} className="decline-btn">
                Decline
              </button>
              <button onClick={handleAccept} className="accept-btn">
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookiePopup;
